import {GlasContainerMarkerManager} from "./GlasContainerMarkerManager.js";
export class GlasContainerMapManager {
  constructor(mapContainer, radiusSelectElement, locationHitsSpanElement, glasContainerForm, glasContainerReturnChannelForm) {
    this.mapContainer = mapContainer;
    this.radiusSelectElement = radiusSelectElement;
    this.locationHitsSpanElement = locationHitsSpanElement;
    this.glasContainerForm = glasContainerForm;
    this.radiusSelect = radiusSelectElement;
    this.locationHitsSpan = locationHitsSpanElement;
    this.map = new google.maps.Map(this.mapContainer, {
      zoom: this.calculateZoomLevel(),
      center: {lat: 0, lng: 0},
      fullscreenControl: false
    });
    this.markerManager = new GlasContainerMarkerManager(this.map, this.glasContainerForm, glasContainerReturnChannelForm);
    this.radiusSelect.addEventListener("change", () => {
      this.hideAllGlasContainersOutsideTheRadius();
      this.updateLocationHitsDisplay();
    });
  }
  async initMap(glasContainerLocations, userPosition) {
    this.userPosition = userPosition;
    this.map.setCenter(userPosition);
    this.map.setZoom(this.calculateZoomLevel());
    this.addUserPositionMarker(userPosition);
    await this.addMarkersToMap(glasContainerLocations);
    this.hideAllGlasContainersOutsideTheRadius();
    this.updateLocationHitsDisplay();
  }
  addUserPositionMarker(userPosition) {
    if (this.userPositionMarker) {
      this.userPositionMarker.setMap(null);
    }
    this.userPositionMarker = new google.maps.Marker({
      position: userPosition,
      map: this.map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillOpacity: 1,
        strokeWeight: 4,
        fillColor: "#5384ED",
        strokeColor: "#ffffff"
      }
    });
  }
  async addMarkersToMap(glasContainerLocations) {
    this.markerManager.clearMarkers();
    for (const location of glasContainerLocations) {
      await this.markerManager.addMarker(location);
    }
  }
  updateLocationHitsDisplay() {
    const visibleMarkersCount = this.markerManager.getVisibleMarkersCount();
    this.locationHitsSpan.innerText = String(visibleMarkersCount);
  }
  calculateZoomLevel() {
    const radius = parseInt(this.radiusSelect.value, 10);
    switch (radius) {
      case 1:
        return 14;
      case 5:
        return 12;
      case 10:
        return 11;
      case 15:
      case 20:
        return 10;
      default:
        return 8;
    }
  }
  hideAllGlasContainersOutsideTheRadius() {
    const radius = parseInt(this.radiusSelect.value, 10) * 1e3;
    this.map.setCenter(this.userPosition);
    this.map.setZoom(this.calculateZoomLevel());
    if (this.userPositionMarker) {
      this.markerManager.updateMarkersVisibility(this.userPositionMarker.getPosition(), radius);
    }
  }
}
